export function buildUrl(imagePath) {
  return `https://${process.env.GATSBY_IMGIX_SOURCE}/${imagePath}`;
}
